import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { authSelectors } from '@ucheba/store/auth'
import { institutionItemSelectors } from '@ucheba/store/institutions/item'
import { useRouter } from 'next/router'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Divider } from '@ucheba/ui/components/Divider/desktop'
import { p11n } from '@ucheba/utils/helpers/string'
import { feedbacksSelectors, feedbacksThunks } from '@ucheba/store/feedbacks'
import { LimitedList } from '@ucheba/ui/components/LimitedList/desktop'
import { EActivityTypes } from '@ucheba/utils/types/userActivityTypes'
import UsersCommunication from '../../../../../../components/UsersCommunication/desktop'
import Pagination from '../../../../components/Pagination/desktop'
import { useUserActivity } from '../../../../../../../utils/hooks/useUserActivity'
import { EActivityInfoPart } from '../../../../../../components/InstitutionExams/types'
import { useBannerProgramTypes } from '../../utils/useBannerProgramTypes'
import { isPaidPackage } from '../../utils/isPaidPackage'
import { IListFeedbacksProps } from '../types'

const ListFeedbacks: FC<IListFeedbacksProps> = (props) => {
  const { offset, onAfterSubmit, limit } = props
  const feedbacks = useSelector(feedbacksSelectors.entity)

  const data = useSelector(institutionItemSelectors.currentInstitution)
  const router = useRouter()
  const { feedbackStats } = data || {}
  const institutionRate = feedbackStats?.score
  const isAuth = useSelector(authSelectors.isAuth)
  const { query } = router

  const { setUserActivity } = useUserActivity()

  const dispatch = useDispatch()

  const handleShowAllClick = async (): Promise<void> => {
    if (!isAuth) {
      await dispatch(
        feedbacksThunks.fetch({
          data: {
            id: query.id,
            type: 'institution',
            limit: 20,
            offset: Number(query.page) > 1 ? (Number(query.page) - 1) * 20 : 0,
          },
        })
      )
    }
    await setUserActivity({
      activityType: EActivityTypes.infoPartViewed,
      institutionId: Array.isArray(query.id) ? Number(query.id[0]) : Number(query.id),
      data: { infoPart: EActivityInfoPart.opinions },
    })
  }

  const { extraParams, paidPackage } = useBannerProgramTypes()

  if (!feedbacks?.items.length) return null

  return (
    <>
      <LimitedList
        onShowAll={handleShowAllClick}
        isAuth={isAuth}
        id='feedbacks'
        limit={isAuth ? undefined : 5}
        items={feedbacks.items}
        total={feedbacks.total}
        buttonText='Показать все отзывы'
        showAllButtonLinkIsLink={false}
      >
        {({ limitedItems, isOpen }) => {
          return (
            <>
              <UsersCommunication
                isBanner={!isPaidPackage(paidPackage)}
                params={extraParams}
                institutionRate={institutionRate}
                items={limitedItems}
                total={feedbacks.total}
                type='feedbacks'
                rootType='institution'
                rootId={data.id}
                limit={limit}
                offset={offset}
                onAfterSubmit={onAfterSubmit}
                titleAs='h1'
              />

              {feedbacks.total > 20 && isOpen && (
                <>
                  <Divider />

                  <Pagination
                    total={feedbacks?.total}
                    showItemsCount={20}
                    totalCount={`${feedbacks?.total} ${p11n(
                      feedbacks?.total || 0,
                      'отзыв',
                      'отзыва',
                      'отзывов'
                    )}`}
                  />
                </>
              )}
            </>
          )
        }}
      </LimitedList>

      <Spacing spacing='uxlarge' />
    </>
  )
}

export default ListFeedbacks
